import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';

class DropDownChonHinhThucThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownChonHinhThucThanhTra.defaultProps = {
  label: 'Hình thức',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: []
}

let bindStateToProps = state => {
  return {
    data: [
      {giaTri: 'Cũ', ten: 'Cũ'},
      {giaTri: 'Mới', ten: 'Mới'}
    ]
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonHinhThucThanhTra));


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonHinhThucThanhTra.jsx